import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const NO_BACK = ['/', '/dashboard', '/login', '/register'];

const BackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  if (NO_BACK.includes(location.pathname)) return null;

  return (
    <button
      onClick={() => navigate(-1)}
      className="fixed top-20 left-4 z-50 p-2.5 rounded-xl shadow-lg backdrop-blur-md transition-all hover:-translate-x-0.5 active:scale-95"
      style={{
        background: isDark ? 'rgba(26,26,46,0.85)' : 'rgba(255,255,255,0.9)',
        border: `1px solid ${isDark ? '#2E2E45' : '#E5E3F0'}`,
        boxShadow: isDark ? '0 4px 16px rgba(0,0,0,0.3)' : '0 4px 16px rgba(0,0,0,0.08)'
      }}
      data-testid="global-back-btn"
      aria-label="Retour"
    >
      <ArrowLeft className="h-5 w-5" style={{ color: isDark ? '#F0EFFF' : '#1A1A2E' }} />
    </button>
  );
};

export default BackButton;
